import React from 'react';

const NotFound = () => {
    return (
        <div className=' bg-[#f0f0f0] py-40 text-center'>
            <img className='mx-auto' src="https://i.ibb.co/JnjK81Y/not-Found-404.jpg" alt="" />
        </div>
    );
};

export default NotFound;